import React, { useState } from "react";
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  styled,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Inbox, Mail, MenuBook } from "@mui/icons-material";
import useSelectedModule from "hooks/useSelectedModule";
import { ModuleType } from "redux/moduleSlice";

const CustomListItemButton = styled(ListItemButton)({
  "&.Mui-selected": {
    backgroundColor: "#AEECFF",
  },
  ":hover": {
    backgroundColor: "#AEECFF",
  },
});

const drawerWidth = 300;

const CustomListItemText = styled(ListItemText)({
  marginLeft: "30px",
});

export const Menu = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const [selectedIndex, setSelectedIndex] = useState<null | number>(null);
  const { selectedModule } = useSelectedModule();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
    setSelectedIndex(index);
    if (isMobile) handleDrawerToggle();
  };

  const drawerContent = (
    <>
      <Toolbar />
      <Box sx={{ overflow: "auto", marginTop: "70px" }}>
        {selectedModule === ModuleType.Orders && (
          <Box>
            <List component="nav" aria-label="reports" subheader={<ListSubheader>Reportes</ListSubheader>}>
              <Link to="ordenes" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
                  <CustomListItemText primary="Ordenes" />
                </CustomListItemButton>
              </Link>
              <Link to="clientes" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
                  <CustomListItemText primary="Clientes" />
                </CustomListItemButton>
              </Link>
              <Link to="devices" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)}>
                  <CustomListItemText primary="Dispositivos" />
                </CustomListItemButton>
              </Link>
            </List>
            <Divider />
            <List component="nav" aria-label="tools" subheader={<ListSubheader>Herramientas</ListSubheader>}>
              <Link to="notificaciones" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)}>
                  <CustomListItemText primary="Notificaciones" />
                </CustomListItemButton>
              </Link>
            </List>
            <Divider />
            <List component="nav" aria-label="sales" subheader={<ListSubheader>Ventas</ListSubheader>}>
              <Link to="facturacion" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 4} onClick={(event) => handleListItemClick(event, 4)}>
                  <CustomListItemText primary="Facturación" />
                </CustomListItemButton>
              </Link>
              <Link to="facturas-generadas" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 5} onClick={(event) => handleListItemClick(event, 5)}>
                  <CustomListItemText primary="Facturas generadas" />
                </CustomListItemButton>
              </Link>
            </List>
            <Divider />
            <List component="nav" aria-label="sales" subheader={<ListSubheader>Administración</ListSubheader>}>
              <Link to="activeOrders" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 6} onClick={(event) => handleListItemClick(event, 6)}>
                  <CustomListItemText primary="Ordenes activas" />
                </CustomListItemButton>
              </Link>
              <Link to="liveDrivers" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 7} onClick={(event) => handleListItemClick(event, 7)}>
                  <CustomListItemText primary="Drivers en vivo" />
                </CustomListItemButton>
              </Link>
              <Link to="shifts" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 8} onClick={(event) => handleListItemClick(event, 8)}>
                  <CustomListItemText primary="Horarios" />
                </CustomListItemButton>
              </Link>
              <Link to="branches" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 9} onClick={(event) => handleListItemClick(event, 9)}>
                  <CustomListItemText primary="Sucursales" />
                </CustomListItemButton>
              </Link>
              <Link to="products-services" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton
                  selected={selectedIndex === 10}
                  onClick={(event) => handleListItemClick(event, 10)}
                >
                  <CustomListItemText primary="Productos  y Servicios" />
                </CustomListItemButton>
              </Link>
              <Link to="servicio-al-cliente" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton
                  selected={selectedIndex === 11}
                  onClick={(event) => handleListItemClick(event, 11)}
                >
                  <CustomListItemText primary="Servicio al cliente" />
                </CustomListItemButton>
              </Link>
              <Link to="drivers" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton
                  selected={selectedIndex === 12}
                  onClick={(event) => handleListItemClick(event, 12)}
                >
                  <CustomListItemText primary="Drivers" />
                </CustomListItemButton>
              </Link>
            </List>
          </Box>
        )}

        {selectedModule === ModuleType.Travels && (
          <Box>
            <List component="nav" aria-label="sales" subheader={<ListSubheader>Administración</ListSubheader>}>
              <Link to="travels" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
                  <CustomListItemText primary="Historial de viajes" />
                </CustomListItemButton>
              </Link>
              <Link to="active-travels" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
                  <CustomListItemText primary="Viajes Activos" />
                </CustomListItemButton>
              </Link>

              <Link to="transportDrivers" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)}>
                  <CustomListItemText primary="Conductores" />
                </CustomListItemButton>
              </Link>
              <Link to="vehicleTypes" style={{ textDecoration: "none", color: "inherit" }}>
                <CustomListItemButton selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)}>
                  <CustomListItemText primary="Tipos de vehiculos" />
                </CustomListItemButton>
              </Link>
            </List>
          </Box>
        )}
      </Box>
    </>
  );

  return (
    <>
      {isMobile && (
        <AppBar position="fixed">
          <Toolbar>
            <IconButton edge="start" onClick={handleDrawerToggle}>
              <MenuBook />
            </IconButton>
            <Typography variant="h6">El Chalet</Typography>
          </Toolbar>
        </AppBar>
      )}

      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        anchor={isMobile ? "top" : "left"}
        open={isMobile ? mobileOpen : true}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }} // improve performance on mobile
        sx={{
          ...(isMobile
            ? { "& .MuiDrawer-paper": { height: "auto" } }
            : {
                width: drawerWidth,
                flexShrink: 0,
                zIndex: 1,
                "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box" },
              }),
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};
